import pick from 'lodash.pick';

const styledSpacesList = ['m', 'mx', 'my', 'mt', 'mr', 'mb', 'ml', 'p', 'px', 'py', 'pt', 'pr', 'pb', 'pl'];
const styledSpaces = (spaces: any) => pick(spaces, styledSpacesList);

export default styledSpaces;
